import React from "react";

import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

interface StyledTransshipmentBadgeProps {
  backgroundColor: string;
  textColor: string;
}

export const SytledTransshipmentBadge = styled("div", {
  shouldForwardProp: (prop) => prop !== "backgroundColor" && prop !== "textColor",
})<StyledTransshipmentBadgeProps>(({ backgroundColor, textColor }) => ({
  display: "inline-block",
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: "12px",
  lineHeight: "16px",
  background: `${backgroundColor} !important`,
  color: `${textColor} !important`,
  padding: "8px 12px",
  borderRadius: "100px",
}));

type Props = {
  value?: string;
  backgroundColor?: string;
  dataCy?: string;
  textColor?: string;
  className?: string;
};

export enum TransshipmentStatus {
  CREATED = "Created",
  DRAFT = "Draft",
  PUBLISHED = "Published",
  STARTED = "Started",
  IN_PROGRESS = "In Progress",
  COMPLETED = "Completed",
  CANCELLED = "Cancelled",
}

const BadgeTransshipmentStatus = (props: Props) => {
  const { value, className, dataCy } = props;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return (
        <SytledTransshipmentBadge
          data-cy={dataCy}
          backgroundColor={backgroundColor}
          textColor={textColor}
          className={className}
        >
          {value}
        </SytledTransshipmentBadge>
      );

    return <> </>;
  };

  switch (value?.toLowerCase()) {
    case TransshipmentStatus.IN_PROGRESS.toLowerCase():
      return renderBadge(colors.warning50, colors.warning600, value);
    case TransshipmentStatus.STARTED.toLowerCase():
      return renderBadge(colors.purple50, colors.purple600, value);
    case TransshipmentStatus.DRAFT.toLowerCase():
      return renderBadge(colors.gray100, colors.gray600, value);
    case TransshipmentStatus.PUBLISHED.toLowerCase():
      return renderBadge(colors.purple50, colors.purple600, value);
    case TransshipmentStatus.CANCELLED.toLowerCase():
      return renderBadge(colors.error50, colors.error600, value);
    case TransshipmentStatus.COMPLETED.toLowerCase():
      return renderBadge(colors.success50, colors.success600, value);
    default:
      return renderBadge(colors.gray100, colors.gray600, value);
  }
};

export default BadgeTransshipmentStatus;
